import { FilterXSS, IFilterXSSOptions } from 'xss';

import { isObjKey } from './utils';

export class Sanitizer {
    customXss: FilterXSS;
    constructor() {
        const xssOptions: IFilterXSSOptions = {
            whiteList: {
                a: ['href', 'id', 'class'],
            },
            stripIgnoreTag: true,
            stripIgnoreTagBody: ['script'],
        };
        this.customXss = new FilterXSS(xssOptions);
    }
    private sanitizeString(input: string): string {
        return this.customXss.process(input);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public sanitize(data: any): any {
        if (typeof data === 'string') {
            return this.sanitizeString(data);
        } else if (Array.isArray(data)) {
            return data.map((item) => this.sanitize(item));
        } else if (typeof data === 'object' && data != null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const sanitizedObject: any = {};
            for (const key in data) {
                if (isObjKey(key, data)) {
                    const sanitizedKey = this.sanitizeString(key);
                    sanitizedObject[sanitizedKey] = this.sanitize(data[key]);
                }
            }
            return sanitizedObject;
        }
        return data ?? '';
    }
}
